import React, { useCallback, useEffect, useState } from "react";
import api from "../../util/panelApi";
import { PageHead, Tiles, Chip, Table, Pager, Tabs, img, fmt, when } from "./kit";

/// Coin dokumu: bir kullanicinin coin'i nereden geldi, nereye gitti (oyun, hediye, arama...).
/// Magaza alisverisleri: App Store / Google, gercek mi deneme mi, basarisiz dogrulamalar.
const GUNLER = [
  ["0", "Tüm zamanlar"],
  ["1", "Son 24 saat"],
  ["7", "7 gün"],
  ["30", "30 gün"],
];

const net = (n) => <b style={{ color: n < 0 ? "#B91C1C" : n > 0 ? "#047857" : undefined }}>{n > 0 ? "+" : ""}{fmt(n)}</b>;

const Dokum = ({ ilkQ }) => {
  const [q, setQ] = useState(ilkQ || "");
  const [days, setDays] = useState("0");
  const [d, setD] = useState(null);
  const [busy, setBusy] = useState(false);
  const [hata, setHata] = useState("");

  const yukle = useCallback(async (aranan, gun) => {
    if (!String(aranan || "").trim()) return;
    setBusy(true);
    setHata("");
    const r = await api.coinFlow(aranan.trim(), gun);
    setBusy(false);
    if (r?.status) setD(r);
    else {
      setD(null);
      setHata(r?.message || "Bulunamadı");
    }
  }, []);
  useEffect(() => {
    if (ilkQ) yukle(ilkQ, "0");
  }, [ilkQ, yukle]);

  const a = d?.account;
  const o = d?.ozet;
  const [dm, setDm] = useState("");
  const deneme = async (body, onay) => {
    if (!window.confirm(onay)) return;
    const r = await api.denemeCoin({ q: String(a.uniqueID || a.id), ...body });
    window.alert(r?.message || (r?.status ? "Tamam" : "Yapılamadı"));
    if (r?.status) {
      setDm("");
      yukle(q, days);
    }
  };
  return (
    <>
      <form
        className="d-flex"
        style={{ gap: 8, marginBottom: 12, flexWrap: "wrap" }}
        onSubmit={(e) => {
          e.preventDefault();
          yukle(q, days);
        }}
      >
        <input className="form-control" style={{ maxWidth: 260 }} placeholder="Kullanıcı ID (ör. 3383962)" value={q} onChange={(e) => setQ(e.target.value)} />
        <select
          className="form-control"
          style={{ maxWidth: 160 }}
          value={days}
          onChange={(e) => {
            setDays(e.target.value);
            if (d) yukle(q, e.target.value);
          }}
        >
          {GUNLER.map(([k, l]) => (
            <option key={k} value={k}>
              {l}
            </option>
          ))}
        </select>
        <button className="btn btn-primary" disabled={busy}>
          {busy ? "…" : "Göster"}
        </button>
      </form>
      {hata && <div className="badu-empty">{hata}</div>}
      {a && (
        <>
          <div className="card" style={{ marginBottom: 12 }}>
            <div className="card-body d-flex align-items-center" style={{ gap: 12, flexWrap: "wrap" }}>
              {a.image ? <img src={img(a.image)} alt="" style={{ width: 52, height: 52, borderRadius: "50%", objectFit: "cover" }} /> : null}
              <div>
                <div style={{ fontWeight: 800, fontSize: 17 }}>{a.name}</div>
                <div style={{ fontSize: 12.5, color: "#6B7280" }}>
                  ID {a.uniqueID} · {a.country || "—"} · Kayıt {when(a.createdAt)} {a.kind === "host" ? "· Yayıncı" : ""}
                </div>
              </div>
              <div style={{ display: "flex", gap: 6, flexWrap: "wrap", marginLeft: "auto" }}>
                {a.testCoin > 0 && <Chip kind="warn">Deneme coin: {fmt(a.testCoin)}</Chip>}
                {a.isBlock && <Chip kind="bad">Kapalı</Chip>}
                {a.vip && <Chip kind="ok">VIP {a.vip.level}</Chip>}
              </div>
            </div>
          </div>
          <div className="card" style={{ marginBottom: 12 }}>
            <div className="card-body" style={{ display: "flex", gap: 8, alignItems: "center", flexWrap: "wrap" }}>
              <b style={{ marginRight: 6 }}>Deneme coin</b>
              <span style={{ fontSize: 12.5, color: "#6B7280", flex: "1 1 260px" }}>
                Deneme coinle yapılan hediye, arama ve mesaj karşı tarafa kazanç (elmas, maaş, ajans payı) yazmaz; kayıp iadesi verilmez. Önce deneme coin harcanır.
              </span>
              <input className="form-control" style={{ maxWidth: 160 }} placeholder="Miktar" value={dm} onChange={(e) => setDm(e.target.value.replace(/[^0-9]/g, ""))} />
              <button className="btn btn-warning" disabled={!dm} onClick={() => deneme({ miktar: Number(dm) }, `${a.name} (ID ${a.uniqueID}) hesabına ${fmt(dm)} DENEME coin yüklensin mi?`)}>
                Deneme coin yükle
              </button>
              <button className="btn btn-outline-warning" onClick={() => deneme({ mevcut: true }, `${a.name} (ID ${a.uniqueID}) hesabının mevcut ${fmt(a.coin)} coin bakiyesinin tamamı deneme coin sayılsın mı?`)}>
                Mevcut bakiyeyi deneme yap
              </button>
            </div>
          </div>
          <Tiles
            items={[
              { label: "Şu anki coin", value: fmt(a.coin) },
              ...(a.testCoin > 0 ? [{ label: "Bunun deneme coin kısmı", value: fmt(a.testCoin) }] : []),
              { label: "Gelen (gerçek)", value: fmt(o.gelen) },
              { label: "Giden (hediye, arama…)", value: fmt(o.giden) },
              { label: "Oyun net", value: net(o.oyunNet) },
              ...(o.deneme ? [{ label: "Deneme alışveriş", value: fmt(o.deneme) }] : []),
              ...(o.beklenen != null ? [{ label: "Kayıtsız fark", value: net(a.coin - o.beklenen) }] : []),
            ]}
          />
          {o.beklenen != null && Math.abs(a.coin - o.beklenen) > 0 && (
            <div style={{ fontSize: 12.5, color: "#6B7280", margin: "-4px 0 12px" }}>
              Kayıtsız fark: kayıtlara göre bakiye {fmt(o.beklenen)} olmalıydı, gerçekte {fmt(a.coin)}. Fark, kaydı tutulmayan bir giriş/çıkış (paket, eski sistem, elle düzeltme) demektir.
            </div>
          )}

          <h6 style={{ margin: "16px 0 8px" }}>Oyunlar</h6>
          <Table
            head={["Oyun", "El", "Bahis", "Kazanç", "Net"]}
            empty="Oyun oynamamış."
            rows={d.oyunlar.map((g) => (
              <tr key={g.ad}>
                <td>
                  <b>{g.ad}</b>
                </td>
                <td>{fmt(g.n)}</td>
                <td>{fmt(g.bet)}</td>
                <td>{fmt(g.win)}</td>
                <td>{net(g.net)}</td>
              </tr>
            ))}
          />

          <div style={{ display: "grid", gap: 12, gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))" }}>
            <div>
              <h6 style={{ margin: "8px 0" }}>Gelen coin</h6>
              <Table
                head={["Kaynak", "Adet", "Coin"]}
                rows={d.gelen.map((x) => (
                  <tr key={x.ad}>
                    <td>
                      {x.ad} {x.deneme && <Chip kind="warn">Deneme</Chip>}
                    </td>
                    <td>{fmt(x.n)}</td>
                    <td>
                      <b>{fmt(x.coin)}</b>
                    </td>
                  </tr>
                ))}
              />
            </div>
            <div>
              <h6 style={{ margin: "8px 0" }}>Giden coin</h6>
              <Table
                head={["Nereye", "Adet", "Coin"]}
                rows={d.giden.map((x) => (
                  <tr key={x.ad}>
                    <td>{x.ad}</td>
                    <td>{fmt(x.n)}</td>
                    <td>
                      <b>{fmt(x.coin)}</b>
                    </td>
                  </tr>
                ))}
              />
            </div>
          </div>

          <div style={{ display: "grid", gap: 12, gridTemplateColumns: "repeat(auto-fit, minmax(320px, 1fr))" }}>
            <div>
              <h6 style={{ margin: "8px 0" }}>En çok hediye gönderdiği</h6>
              <Table
                head={["Alıcı", "Hediye", "Coin"]}
                empty="Hediye göndermemiş."
                rows={d.alicilar.map((x, i) => (
                  <tr key={i}>
                    <td>
                      {x.name} <span style={{ color: "#6B7280", fontSize: 12 }}>ID {x.uniqueID}</span>
                    </td>
                    <td>{fmt(x.n)}</td>
                    <td>
                      <b>{fmt(x.coin)}</b>
                    </td>
                  </tr>
                ))}
              />
            </div>
            <div>
              <h6 style={{ margin: "8px 0" }}>Yetkililerin verdiği paketler</h6>
              <Table
                head={["Paket", "Veren", "Tarih"]}
                empty="Paket verilmemiş."
                rows={d.paketler.map((x, i) => (
                  <tr key={i}>
                    <td>{x.ad}</td>
                    <td>{x.veren}</td>
                    <td>{when(x.at)}</td>
                  </tr>
                ))}
              />
            </div>
          </div>

          <h6 style={{ margin: "8px 0" }}>Son hareketler</h6>
          <Table
            head={["Tarih", "Tür", "Coin", "Not"]}
            rows={d.son.map((x, i) => (
              <tr key={i}>
                <td>{when(x.at)}</td>
                <td>{x.tur}</td>
                <td>{net(x.gelir ? Math.abs(x.coin) : -Math.abs(x.coin))}</td>
                <td style={{ fontSize: 12, color: "#6B7280" }}>{x.not}</td>
              </tr>
            ))}
          />
        </>
      )}
    </>
  );
};

const Alisveris = ({ ac }) => {
  const [d, setD] = useState(null);
  const [page, setPage] = useState(1);
  const [env, setEnv] = useState("");
  const [platform, setPlatform] = useState("");

  const load = useCallback(async () => {
    setD(null);
    const r = await api.storePurchases({ page, size: 50, env, platform });
    setD(r?.status ? r : { rows: [], total: 0, ozet: [], hatalar: [] });
  }, [page, env, platform]);
  useEffect(() => {
    load();
  }, [load]);

  const oz = (p, dn) => d?.ozet?.find((x) => x.platform === p && x.deneme === dn);
  return (
    <>
      {d && (
        <Tiles
          items={[
            { label: "Son 24 saat · App Store (gerçek)", value: fmt(oz("ios", false)?.n) },
            { label: "Son 24 saat · Google (gerçek)", value: fmt(oz("android", false)?.n) },
            { label: "Son 24 saat · deneme", value: fmt((oz("ios", true)?.n || 0) + (oz("android", true)?.n || 0)) },
            { label: "Başarısız doğrulama (son 30)", value: fmt(d.hatalar?.length) },
          ]}
        />
      )}
      <div className="d-flex" style={{ gap: 8, marginBottom: 10, flexWrap: "wrap" }}>
        <select className="form-control" style={{ maxWidth: 170 }} value={env} onChange={(e) => (setPage(1), setEnv(e.target.value))}>
          <option value="">Hepsi</option>
          <option value="real">Sadece gerçek</option>
          <option value="test">Sadece deneme</option>
        </select>
        <select className="form-control" style={{ maxWidth: 170 }} value={platform} onChange={(e) => (setPage(1), setPlatform(e.target.value))}>
          <option value="">iPhone + Android</option>
          <option value="ios">iPhone</option>
          <option value="android">Android</option>
        </select>
      </div>
      <Table
        loading={!d}
        head={["Tarih", "Kullanıcı", "Platform", "Paket", "Coin", "Durum"]}
        rows={(d?.rows || []).map((r) => (
          <tr key={r.transactionId}>
            <td>{when(r.at)}</td>
            <td>
              <button type="button" className="btn btn-link btn-sm p-0" onClick={() => ac(r.user.uniqueID || r.user.id)}>
                {r.user.name}
              </button>{" "}
              <span style={{ color: "#6B7280", fontSize: 12 }}>ID {r.user.uniqueID}</span>
            </td>
            <td>{r.platform === "ios" ? "App Store" : "Google Play"}</td>
            <td style={{ fontSize: 12 }}>{r.productId}</td>
            <td>
              <b>{fmt(r.coin)}</b>
            </td>
            <td>{r.deneme ? <Chip kind="warn">Deneme (para çekilmedi)</Chip> : <Chip kind="ok">Gerçek</Chip>}</td>
          </tr>
        ))}
      />
      {d && <Pager page={page} size={50} total={d.total} onChange={setPage} />}

      <h6 style={{ margin: "18px 0 8px" }}>Başarısız doğrulamalar</h6>
      <div style={{ fontSize: 12.5, color: "#6B7280", marginBottom: 6 }}>
        Kullanıcı ödeme yaptı ama sunucu doğrulayamadıysa burada görünür. Coin yüklenmemiştir; kontrol edip gerekirse elle yükleyin.
      </div>
      <Table
        loading={!d}
        head={["Tarih", "Kullanıcı", "Platform", "Paket", "Sebep"]}
        empty="Başarısız doğrulama yok."
        rows={(d?.hatalar || []).map((h, i) => (
          <tr key={i}>
            <td>{when(h.at)}</td>
            <td>
              {h.user ? (
                <button type="button" className="btn btn-link btn-sm p-0" onClick={() => ac(h.user.uniqueID)}>
                  {h.user.name} · ID {h.user.uniqueID}
                </button>
              ) : (
                "—"
              )}
            </td>
            <td>{h.platform === "ios" ? "App Store" : "Google Play"}</td>
            <td style={{ fontSize: 12 }}>{h.productId}</td>
            <td style={{ fontSize: 12, color: "#B91C1C" }}>{h.message}</td>
          </tr>
        ))}
      />
    </>
  );
};

const CoinFlow = () => {
  const [tab, setTab] = useState("dokum");
  const [kisi, setKisi] = useState("");
  return (
    <>
      <PageHead title="Coin Dökümü" sub="Kullanıcının coin'i nereden geldi, nereye gitti: satın alma, bayi, admin, hediye, arama ve her oyunda kazanç/kayıp. Mağaza alışverişlerinde gerçek ödeme ile deneme (TestFlight/sandbox) ayrı görünür." />
      <Tabs
        tabs={[
          ["dokum", "Kullanıcı dökümü"],
          ["alis", "Mağaza alışverişleri"],
        ]}
        value={tab}
        onChange={setTab}
      />
      {tab === "dokum" ? (
        <Dokum key={kisi} ilkQ={kisi} />
      ) : (
        <Alisveris
          ac={(id) => {
            setKisi(String(id));
            setTab("dokum");
          }}
        />
      )}
    </>
  );
};

export default CoinFlow;
